import React from 'react';
import { makeStyles } from '@material-ui/core/styles'
import CreateGeneral from '../components/general/CreateGeneral';
import Banner from "../components/banner/Banner"
import Login from "../components/login/Login"
import NoticeBanner from "../components/notice/NoticeBanner"


const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "flex-start",

        "@media (min-width: 1334px)": {
            justifyContent: "center",

        },
    },

    LoginNotice: {
        // position: "fixed",
        //  marginLeft: "1300px",
        "@media (max-width: 1000px)": {
            display: "none"
        }

    }
}))

const WriteGeneral = () => {

    const style = useStyles();

    return (
        <>
            <div className={style.container}>
                <div>
                    <Banner />
                    <CreateGeneral />
                </div>
                <div className={style.LoginNotice}>

                    <Login />
                    <NoticeBanner />
                </div>
            </div>
        </>
    );
};

export default WriteGeneral;